import { useMutation } from '@tanstack/react-query';
import * as api from 'util/api';

export default ({ onSuccess, onError, onSettled } = {}) => useMutation({
  mutationKey: ['segmentation', 'approve-run'],
  mutationFn: (runId) => api.approveSegmentationRun(runId),
  onSuccess,
  onError,
  onSettled,
});
